import { carrieMediaArray } from './carrieMedia'
import { carrieBio } from './carrieBios'
import { aidenProfileReviewTinder, mrBigProfileReviewHinge, burgerProfileReviewBumble } from './carrieProfileReviews'

export const carrieDatingProfileHinge = {
  _id: 'carrieDatingProfileHingeId',
  userId: 'carrieUserId',
  email: 'carrie@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: carrieMediaArray[9]._id,
      mediaItemURL: carrieMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[9].type,
      caption: carrieMediaArray[9].captions[2],
      subcaption: carrieMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: carrieMediaArray[1]._id,
      mediaItemURL: carrieMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[1].type,
      caption: carrieMediaArray[1].captions[1],
      subcaption: carrieMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: carrieMediaArray[4]._id,
      mediaItemURL: carrieMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[4].type,
      caption: carrieMediaArray[4].captions[0],
      subcaption: carrieMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[6]._id,
      mediaItemURL: carrieMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[6].type,
      caption: carrieMediaArray[6].captions[0],
      subcaption: carrieMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[7]._id,
      mediaItemURL: carrieMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[7].type,
      caption: carrieMediaArray[7].captions[1],
      subcaption: carrieMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[8]._id,
      mediaItemURL: carrieMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[8].type,
      caption: carrieMediaArray[8].captions[1],
      subcaption: carrieMediaArray[8].subcaptions[1],
    }
  ],
  bio: {
    bioItemsId: carrieBio._id,
    vitalInfo: { ...carrieBio.vitalInfo },
    prompts: [
      { ...carrieBio.prompts[0] },
      { ...carrieBio.prompts[1] },
      { ...carrieBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...mrBigProfileReviewHinge }
  ],
  mediaItems: [ ...carrieMediaArray ],
  bioItems: { ...carrieBio },
}

export const carrieDatingProfileBumble = {
  _id: 'carrieDatingProfileBumbleId',
  userId: 'carrieUserId',
  email: 'carrie@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: carrieMediaArray[4]._id,
      mediaItemURL: carrieMediaArray[4].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[4].type,
      caption: carrieMediaArray[4].captions[0],
      subcaption: carrieMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[8]._id,
      mediaItemURL: carrieMediaArray[8].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[8].type,
      caption: carrieMediaArray[8].captions[1],
      subcaption: carrieMediaArray[8].subcaptions[1],
    },
    {
      mediaItemId: carrieMediaArray[1]._id,
      mediaItemURL: carrieMediaArray[1].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[1].type,
      caption: carrieMediaArray[1].captions[1],
      subcaption: carrieMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: carrieMediaArray[6]._id,
      mediaItemURL: carrieMediaArray[6].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[6].type,
      caption: carrieMediaArray[6].captions[0],
      subcaption: carrieMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[7]._id,
      mediaItemURL: carrieMediaArray[7].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[7].type,
      caption: carrieMediaArray[7].captions[1],
      subcaption: carrieMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[9]._id,
      mediaItemURL: carrieMediaArray[9].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: carrieMediaArray[9].type,
      caption: carrieMediaArray[9].captions[2],
      subcaption: carrieMediaArray[9].subcaptions[2],
    }
  ],
  bio: {
    bioItemsId: carrieBio._id,
    vitalInfo: { ...carrieBio.vitalInfo },
    prompts: [
      { ...carrieBio.prompts[0] },
      { ...carrieBio.prompts[1] },
      { ...carrieBio.prompts[2] }
    ],
    aboutMe: carrieBio.aboutMe[0],
    hobbies: [carrieBio.hobbies[0], carrieBio.hobbies[1], carrieBio.hobbies[2], carrieBio.hobbies[3], carrieBio.hobbies[4] ],
  },
  profileReviews: [
    { ...burgerProfileReviewBumble }
  ],
  mediaItems: [ ...carrieMediaArray ],
  bioItems: { ...carrieBio },
}

export const carrieDatingProfileTinder = {
  _id: 'carrieDatingProfileTinderId',
  userId: 'carrieUserId',
  email: 'carrie@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: carrieMediaArray[7]._id,
      mediaItemURL: carrieMediaArray[7].portraitURL,
      mediaType: carrieMediaArray[7].type,
      caption: carrieMediaArray[7].captions[1],
      subcaption: carrieMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[1]._id,
      mediaItemURL: carrieMediaArray[1].portraitURL,
      mediaType: carrieMediaArray[1].type,
      caption: carrieMediaArray[1].captions[1],
      subcaption: carrieMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: carrieMediaArray[4]._id,
      mediaItemURL: carrieMediaArray[4].portraitURL,
      mediaType: carrieMediaArray[4].type,
      caption: carrieMediaArray[4].captions[0],
      subcaption: carrieMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[8]._id,
      mediaItemURL: carrieMediaArray[8].portraitURL,
      mediaType: carrieMediaArray[8].type,
      caption: carrieMediaArray[8].captions[1],
      subcaption: carrieMediaArray[8].subcaptions[1],
    },
    {
      mediaItemId: carrieMediaArray[6]._id,
      mediaItemURL: carrieMediaArray[6].portraitURL,
      mediaType: carrieMediaArray[6].type,
      caption: carrieMediaArray[6].captions[0],
      subcaption: carrieMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: carrieMediaArray[9]._id,
      mediaItemURL: carrieMediaArray[9].portraitURL,
      mediaType: carrieMediaArray[9].type,
      caption: carrieMediaArray[9].captions[2],
      subcaption: carrieMediaArray[9].subcaptions[2],
    }
  ],
  bio: {
    bioItemsId: carrieBio._id,
    vitalInfo: { ...carrieBio.vitalInfo },
    prompts: [
      { ...carrieBio.prompts[0] },
      { ...carrieBio.prompts[1] },
      { ...carrieBio.prompts[2] }
    ],
    aboutMe: carrieBio.aboutMe[0],
    hobbies: [carrieBio.hobbies[0], carrieBio.hobbies[1], carrieBio.hobbies[2], carrieBio.hobbies[3], carrieBio.hobbies[4] ],
  },
  profileReviews: [
    { ...aidenProfileReviewTinder }
  ],
  mediaItems: [ ...carrieMediaArray ],
  bioItems: { ...carrieBio },
}